const fetchSync = (url) => {
    const request = new XMLHttpRequest();
    request.open('GET', url, false);
    request.send(null);

    if (request.status === 200) {
        return JSON.parse(request.responseText);
    }
    return null;
}

export {
    fetchSync
}